module.exports = __webpack_public_path__ + "static/media/correct.a9824810.svg";